import axios from '@/utils/axios';
const apiUrl = {
  //主页的接口
  getAdvLogList: '/extractor/tt/adv/log/search',
  exportExcel: '/extractor/tt/adv/log/export',
  getXhsAdvLogList: '/xiaohongshu/adv/log/search',
  exportXhsExcel: '/xiaohongshu/adv/log/export',
};

//查询接口
export function getAdvLogListData(params) {
  return axios.post(apiUrl.getAdvLogList, params);
}
export function exportExcel(param) {
  return axios.post(apiUrl.exportExcel, param, {
    timeout: 30 * 1000,
    withCredentials: true,
    responseType: 'blob',
  });
}

// 小红书操作日志
export function getXhsAdvLogListData(params) {
  return axios.post(apiUrl.getXhsAdvLogList, params);
}
export function exportXhsExcel(param) {
  return axios.post(apiUrl.exportXhsExcel, param, {
    timeout: 30 * 1000,
    withCredentials: true,
    responseType: 'blob',
  });
}
